/* eslint-disable padding-line-between-statements */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'ljit-store-connecter';
import ConfirmModal from '../confirm-modal';
import { LoadingStatusEnum } from '../../lib/enums';
import { markNewVersionDetected, useNewVersionDetected } from '../../lib/new-version-signal';

const { SUCCESS } = LoadingStatusEnum;

const CURRENT_VERSION = process.env.APP_VERSION;
const VERSION_URL = '/version.json';
const CHECK_INTERVAL = 5 * 60 * 1000;

const fetchLatestVersion = async () => {
	try {
		const response = await fetch(`${VERSION_URL}?ts=${Date.now()}`, { cache: 'no-store' });

		if (!response.ok) {
			return null;
		}

		const { version } = await response.json();

		return version || null;
	} catch (error) {
		if (process.env.NODE_ENV !== 'production') {
			console.warn('[new-version-notice] version check failed:', error);
		}

		return null;
	}
};

const isNewVersion = version => Boolean(version) && version !== CURRENT_VERSION;

const propTypes = {
	isAuthed: PropTypes.bool,
};

// 三 console 共用：登入後輪詢，偵測到新版即提示重新整理（不自動刷新，免刷掉輸入中的資料）。
function NewVersionNotice({
	isAuthed,
}) {
	const { t } = useTranslation();
	const hasNewVersion = useNewVersionDetected();

	useEffect(() => {
		if (!isAuthed) {
			return;
		}

		const subscription = { isSubscribed: true };

		const checkVersion = async () => {
			const version = await fetchLatestVersion();

			if (subscription.isSubscribed && isNewVersion(version)) {
				markNewVersionDetected();
			}
		};

		const handleVisibilityChange = () => {
			if (document.visibilityState === 'visible') {
				checkVersion();
			}
		};

		// 首檢 + 定時輪詢 + 切回分頁補檢
		checkVersion();

		const intervalId = setInterval(checkVersion, CHECK_INTERVAL);

		document.addEventListener('visibilitychange', handleVisibilityChange);

		return () => {
			subscription.isSubscribed = false;
			clearInterval(intervalId);
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, [isAuthed]);

	return (
		<ConfirmModal
			isVisible={hasNewVersion}
			title={t('提示')}
			message={t('系统已有新版本，请重新整理')}
			okText={t('确认')}
			isHideCancelButton
			onClickOk={() => window.location.reload()}
		/>
	);
}

NewVersionNotice.propTypes = propTypes;

function mapStateToProps(state) {
	return {
		isAuthed: state.auth.get('loadingStatus') === SUCCESS,
	};
}

export default connect(mapStateToProps)(NewVersionNotice);
